export type ThemeMode = "dark" | "light";
export type JuiceLevel = "off" | "standard" | "bold";

export interface Preferences {
  /** Sound-Cues im Antwort-Moment. Bewusst default AUS (Vincent 2026-06-03). */
  sound: boolean;
  /** Lautstaerke 0..1 fuer die Sound-Cues. */
  soundVolume: number;
  theme: ThemeMode;
  /** null = Systemeinstellung (prefers-reduced-motion) folgen. */
  reducedMotion: boolean | null;
  /** Motion-/Feedback-Intensitaet (Dial D1). */
  juice: JuiceLevel;
  /** Haptisches Feedback auf unterstuetzenden Geraeten. */
  haptics: boolean;
  /** Onboarding-Status (separat von der Lern-Engine gehalten). */
  onboardedAt: string | null;
  primaryPathId: string | null;
  dailyGoalItems: number;
}

export const DEFAULT_PREFERENCES: Preferences = {
  sound: false,
  soundVolume: 0.4,
  theme: "light",
  reducedMotion: null,
  juice: "standard",
  haptics: true,
  onboardedAt: null,
  primaryPathId: null,
  dailyGoalItems: 10,
};
